import API from "serviceshift-ui/api-client";

interface Installment {
  id?: number;
  label: string;
  percentage: number;
  position: number;
  _destroy?: boolean;
}

interface Schedule {
  id?: number;
  name: string;
  description?: string;
  is_active: boolean;
  system_default: boolean;
  installments: Installment[];
}

interface Config {
  id: number;
  enabled: boolean;
  tech_override_allowed: boolean;
  default_schedule_id: number | null;
  default_net_days: number | null;
}

interface ScheduleParams {
  name: string;
  description?: string;
  installments_attributes: Installment[];
}

const BASE = "/admin/v4/progress_billing";

export default {
  async fetchProgressBillingConfig(): Promise<Config> {
    const response = await API.makeRequest<{ config: Config }>(
      `${BASE}/config`
    );
    return response.data.config;
  },

  async updateProgressBillingConfig(
    _: unknown,
    config: Partial<Config>
  ): Promise<Config> {
    const response = await API.makeRequest<{ config: Config }>(
      `${BASE}/config`,
      {
        method: "PATCH",
        data: { config }
      }
    );
    return response.data.config;
  },

  async fetchProgressBillingSchedules(): Promise<Schedule[]> {
    const response = await API.makeRequest<{ schedules: Schedule[] }>(
      `${BASE}/schedules`
    );
    return response.data.schedules;
  },

  async fetchProgressBillingSchedule(
    _: unknown,
    id: number
  ): Promise<Schedule> {
    const response = await API.makeRequest<{ schedule: Schedule }>(
      `${BASE}/schedules/${id}`
    );
    return response.data.schedule;
  },

  async createProgressBillingSchedule(
    _: unknown,
    params: ScheduleParams
  ): Promise<Schedule> {
    const response = await API.makeRequest<{ schedule: Schedule }>(
      `${BASE}/schedules`,
      {
        method: "POST",
        data: { schedule: params }
      }
    );
    return response.data.schedule;
  },

  async updateProgressBillingSchedule(
    _: unknown,
    { id, ...params }: { id: number } & Partial<ScheduleParams>
  ): Promise<Schedule> {
    const response = await API.makeRequest<{ schedule: Schedule }>(
      `${BASE}/schedules/${id}`,
      {
        method: "PATCH",
        data: { schedule: params }
      }
    );
    return response.data.schedule;
  },

  async deleteProgressBillingSchedule(_: unknown, id: number): Promise<void> {
    await API.makeRequest(`${BASE}/schedules/${id}`, {
      method: "DELETE"
    });
  },

  async unarchiveProgressBillingSchedule(
    _: unknown,
    id: number
  ): Promise<Schedule> {
    const response = await API.makeRequest<{ schedule: Schedule }>(
      `${BASE}/schedules/${id}/unarchive`,
      { method: "PUT" }
    );
    return response.data.schedule;
  },

  async copyProgressBillingSchedule(_: unknown, id: number): Promise<Schedule> {
    const response = await API.makeRequest<{ schedule: Schedule }>(
      `${BASE}/schedules/${id}/copy`,
      { method: "POST" }
    );
    return response.data.schedule;
  }
};
